import { Questionnaire } from "../types/TakeSurveyType";
import { V1QuestionnaireResource } from "@generated";

const formatTakeSurveys = (data) => {
  const formattedQuestionnaires: Questionnaire[] = [];
  if (data.data && data.data.length > 0) {
    [...data.data]
      .reverse()
      .filter((questionnaire) => questionnaire.attributes.published)
      .map((questionnaire: V1QuestionnaireResource) => {
        //get tags from related questionnaire
        formattedQuestionnaires.push({
          id: Number(questionnaire.id),
          attributes: {
            name: questionnaire.attributes?.name || "",
            description: questionnaire.attributes?.introduction || "",
            teams: questionnaire.attributes?.teams
              ? (questionnaire.attributes?.teams as [])
              : [],
            tags: questionnaire.attributes?.["tag-list"]
              ? questionnaire.attributes["tag-list"]
              : [],
          },
        });
      });
  }
  return {
    data: formattedQuestionnaires,
    meta: { ...data?.meta, "record-count": formattedQuestionnaires.length },
    included: data.included,
  };
};

export default formatTakeSurveys;
